export default "/images/vendor/flag-icons/flags/4x3/lb.svg?048b28a4df1f7e84266fecacf2078c01";